import React from "react";
import styles from "./statusCard.module.scss"; // CSS in separate file or styled-components
import profileImg from "./../../../assets/images/profileImg.png"
import { propTypes } from "react-bootstrap/esm/Image";
import { connect } from "react-redux";

const StatusCard = ({ name="santhosh", logoUrl, leftContent ,loginUser={}}) => {
  return (
    <div className={styles.status}>
      <div className={styles.left}>{leftContent}</div>
      <div className={styles.right}>
        {/* <span className={styles.name}>{loginUser?.fullName}</span> */}
        {/* <img className={styles.logo} src={loginUser?.imageUrl || profileImg} alt="logo" /> */}
      </div>
    </div>
  );
};

const mapStateToProps =(state,props)=>{
  return{
    loginUser:state?.login?.user
  }
}

export default connect(mapStateToProps,null) (StatusCard);
